import { Fragment, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLoad } from "@/lib/hooks";
import { Section, EmptyRow } from "@/components/common";

export function Availability() {
  const [d] = useLoad("/inventory/availability");
  const [open, setOpen] = useState({});
  if (!d) return null;
  if (!d.branches.length) return <Section><p className="p-5 text-sm text-slate-400">No warehouses in scope.</p></Section>;
  return d.branches.map((b) => (
    <Section key={b.branch_id || "none"} title={`${b.branch_name} \u00b7 stock availability`} testId={`availability-${b.branch_id}`} className="mb-4">
      <div className="overflow-x-auto"><table className="po-table" data-testid={`availability-table-${b.branch_id}`}>
        <thead><tr><th /><th>Item</th><th className="po-num">On hand</th><th className="po-num">Issued</th><th className="po-num">Consumed</th><th className="po-num">Waste</th><th className="po-num">Unreported</th><th className="po-num">Available</th></tr></thead>
        <tbody>{b.items.length === 0 && <EmptyRow cols={8} />}
          {b.items.map((i) => { const k = `${b.branch_id}-${i.item_id}`; return (
            <Fragment key={k}>
              <tr data-testid={`availability-row-${i.code}`} className="cursor-pointer" onClick={() => setOpen({ ...open, [k]: !open[k] })}>
                <td>{i.jobs.length > 0 && (open[k] ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />)}</td>
                <td>{i.name}<div className="font-mono text-xs text-slate-400">{i.code} · {i.uom}{i.partials.length ? ` \u00b7 ${i.partials.length} part-used` : ""}</div></td>
                <td className="po-num">{i.on_hand}</td><td className="po-num">{i.issued}</td><td className="po-num">{i.consumed}</td><td className="po-num">{i.waste}</td>
                <td className={`po-num ${i.unreported > 0 ? "text-amber-700" : ""}`}>{i.unreported}</td><td className="po-num font-semibold" data-testid={`availability-available-${i.code}`}>{i.available}</td>
              </tr>
              {open[k] && i.jobs.map((j) => <tr key={`${k}-${j.job_id}`} className="bg-slate-50/70 text-xs" data-testid={`availability-job-${i.code}-${j.job_number}`}>
                <td /><td className="pl-6"><Link to={`/app/jobs/${j.job_id}`} className="font-mono text-[#13294B] underline">{j.job_number}</Link></td><td />
                <td className="po-num">{j.issued}</td><td className="po-num">{j.consumed}</td><td className="po-num">{j.waste}</td><td className="po-num">{j.unreported}</td><td /></tr>)}
            </Fragment>); })}
        </tbody></table></div>
    </Section>
  ));
}
